/** Resolves TaskUIProvider props for Organize drag overlay preview rows. */
export function resolveOrganizeOverlayConfig(activeItem) {
  const view =
    (activeItem && 'view' in activeItem ? activeItem.view : null) ||
    (activeItem.task?.parentId ? 'subtask' : 'master');
  const indentationType =
    (activeItem && 'indentationType' in activeItem
      ? activeItem.indentationType
      : null) || (activeItem.task?.parentId ? 'detail' : 'none');
  const variant =
    (activeItem && 'variant' in activeItem ? activeItem.variant : null) ||
    'default';

  return { view, indentationType, variant };
}
